import React from 'react';
// routes
import CssBaseline from '@mui/material/CssBaseline';
import Router, { IframeRoute, SignInRoute } from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import AuthProvider, { AuthIsSignedIn, AuthIsNotSignedIn, AuthIsIframe } from './utils/AuthContext';
import AppProvider from './utils/AppContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'mapbox-gl/dist/mapbox-gl.css';
// ----------------------------------------------------------------------

export default function App() {
  const [darkMode, setDarkMode] = React.useState(false);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <ThemeProvider darkMode={darkMode}>
      <ScrollToTop />
      <CssBaseline />
      <AuthProvider>
        <AuthIsSignedIn>
          <AppProvider toggleTheme={toggleTheme}>
            <Router />
          </AppProvider>
        </AuthIsSignedIn>
        <AuthIsNotSignedIn>
          <SignInRoute />
        </AuthIsNotSignedIn>
        <AuthIsIframe>
          <AppProvider toggleTheme={toggleTheme}>
            <IframeRoute />
          </AppProvider>
        </AuthIsIframe>
        <ToastContainer
          position="bottom-left"
          hideProgressBar
          autoClose={5000}
          closeOnClick={false}
          newestOnTop={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </AuthProvider>
    </ThemeProvider>
  );
}
